"use client";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { PageSection, PageGridItem, PageFlexItem, PageSectionHeader } from "../structure/page-blocks";
import { Callout } from "../structure/callout";
import { usePixelatedConfig } from "../config/config.client";
import "./socialtags.css";
function getMyLogo(url) {
    const domainBits = new URL(url).hostname.split('.');
    let domain = (domainBits.length <= 2) ? domainBits[0] :
        (domainBits.length > 2) ? domainBits.slice(1, -1).join('.') : domainBits.join('.');
    domain = domain.charAt(0).toUpperCase() + domain.slice(1).toLowerCase();
    const myLogo = `https://www.pixelated.tech/images/logos/${domain.toLowerCase()}-logo.png`;
    return myLogo;
}
/**
 * SocialTags
 * Generates Callouts
 * @param props
 * @returns {JSX.Element}
 */
SocialTags.propTypes = {
    columns: PropTypes.number,
    title: PropTypes.string,
};
export function SocialTags(props) {
    const siteInfo = usePixelatedConfig()?.siteInfo;
    const socials = siteInfo?.socialProfiles ?? [];
    const columns = props.columns ?? (socials.length < 12 ? socials.length : Math.min(Math.ceil(socials.length / 2), 12));
    const sectionTitle = props.title ?? `Follow ${siteInfo?.name ?? ''} on Social Media`;
    return (_jsxs(_Fragment, { children: [_jsx(PageSectionHeader, { url: "", title: sectionTitle }), _jsx(PageSection, { id: "socialtag-section", columns: columns, padding: "0px", children: socials.map((social) => (_jsx(PageGridItem, { children: _jsx(Callout, { variant: "full", imgShape: "squircle", layout: "vertical", url: social.url, img: social.img || getMyLogo(social.url), imgAlt: siteInfo?.name ? `${siteInfo.name} on ${social.name}` : social.name }) }, social.name))) })] }));
}
/**
 * PartnerTags
 * Generates Callouts
 * @param props
 * @returns {JSX.Element}
 */
PartnerTags.propTypes = {
    columns: PropTypes.number,
    title: PropTypes.string,
};
export function PartnerTags(props) {
    const siteInfo = usePixelatedConfig()?.siteInfo;
    const partners = siteInfo?.partners ?? [];
    const columns = props.columns ?? (partners.length < 12 ? partners.length : Math.min(Math.ceil(partners.length / 2), 12));
    const sectionTitle = props.title ?? `${siteInfo?.name ?? ''} Partners`;
    return (_jsxs(_Fragment, { children: [_jsx(PageSectionHeader, { url: "", title: sectionTitle }), _jsx(PageSection, { id: "partnertag-section", columns: columns, padding: "0px", children: partners.map((partner, index) => {
                    if (!partner.url)
                        return null;
                    return (_jsx(PageGridItem, { children: _jsx(PartnersBadge, { company: siteInfo?.name || '', name: partner.name, url: partner.url, img: partner.img || getMyLogo(partner.url) }) }, index));
                }) })] }));
}
function PartnersBadge({ company, name, url, img }) {
    const myimg = (img) ? img : getMyLogo(url);
    return (_jsx(PageFlexItem, { children: _jsx(Callout, { variant: "full", imgShape: "squircle", layout: "vertical", url: url, img: myimg, imgAlt: `${company} on ${name}`, content: name }) }));
}
